/**
 * 云服务类别 产品图表页 react-grid-layout拖动层
 *
 * @format
 */

import React, { useState, useEffect, useRef, FC, useMemo } from 'react'
import styled from 'styled-components'
import { Select, Option } from '@king-design/react'
import { Responsive, WidthProvider } from 'react-grid-layout'
import { gridCols, gridBreakpoints, handleGridLayouts } from '../constants'
import MonitorChartItem from './MonitorChartItem'
import { useWindowSize, useDebounce } from 'react-use'
import { cloneDeep } from 'lodash'

const ResponsiveGridLayout = WidthProvider(Responsive)
const MonitorChartCollapse: FC<any> = ({
  className,
  productType,
  graphs,
  appId,
  tagOpts,
  rangeDate,
  instanceId,
  mointorClassValue,
  openDetails,
  recoverInitView
}) => {
  const [layouts, setLayouts] = useState({})
  const [currentLayout, setCurrentLayout] = useState([])
  const layoutConfig = useRef<{ breakpoints: string; cols: number }>({
    breakpoints: 'lg',
    cols: 12
  })
  const [tags, setTags] = useState<string[]>([])

  useEffect(() => {
    setTags(tagOpts?.length > 3 ? [tagOpts[0]] : [])
  }, [tagOpts])

  const { width, height } = useWindowSize()

  const filterGraph = useMemo(() => {
    if (tags?.length) {
      const graphFilter = graphs.map(item => {
        return {
          ...item,
          lines: item.lines.filter(line => {
            return line.metricType !== 1 || tags.includes(line.tags?.p1)
          })
        }
      })
      return graphFilter.filter(item => item.lines?.length)
    } else {
      return graphs
    }
  }, [graphs, tags])

  useDebounce(
    () => {
      const layout = handleGridLayouts(filterGraph)
      setLayouts(layout)
    },
    200,
    [width, height, filterGraph]
  )

  useEffect(() => {
    const layout = handleGridLayouts(filterGraph)
    setLayouts(layout)
  }, [filterGraph, recoverInitView])

  return (
    <div className={className}>
      {tagOpts?.length ? (
        <div className="tag_select">
          <span>维度：</span>
          <Select
            style={{ width: 500 }}
            value={tags}
            placeholder="默认全部维度"
            multiple
            clearable
            nowrap
            onChangeValue={value => setTags(value)}
          >
            {tagOpts.map(tag => (
              <Option key={tag} value={tag}>
                {tag}
              </Option>
            ))}
          </Select>
        </div>
      ) : null}
      {graphs.length > 0 ? (
        <ResponsiveGridLayout
          layouts={layouts}
          breakpoints={gridBreakpoints}
          cols={gridCols}
          onLayoutChange={layout => {
            setCurrentLayout(layout)
            setLayouts({
              ...layouts,
              [layoutConfig.current.breakpoints]: layout
            })
          }}
          onBreakpointChange={(newBreakpoint, newCols) => {
            layoutConfig.current = {
              breakpoints: newBreakpoint,
              cols: newCols
            }
          }}
        >
          {filterGraph.map((item, index) => {
            return (
              <div key={`${item.graphId?.toString()}-${item.title}`}>
                <MonitorChartItem
                  productType={productType}
                  graph={item}
                  rangeDate={rangeDate}
                  instanceId={instanceId}
                  isRequest={mointorClassValue?.includes(appId)}
                  width={currentLayout[index]?.w}
                  height={currentLayout[index]?.h}
                  openDetails={data => {
                    openDetails(data, tags)
                  }}
                ></MonitorChartItem>
              </div>
            )
          })}
        </ResponsiveGridLayout>
      ) : null}
    </div>
  )
}
export default styled(React.memo(MonitorChartCollapse))`
  .tag_select {
    margin: 16px 0 0 16px;
  }
`
